import React from "react";

const BigCoach = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.5464 13.6263C15.5464 17.3305 18.2036 20.3663 21.5046 20.3663C24.8056 20.3663 27.4628 17.3305 27.4628 13.6263C27.4628 9.92214 24.8056 6.88628 21.5046 6.88628C18.2036 6.88628 15.5464 9.92214 15.5464 13.6263ZM16.7121 13.6263C16.7121 10.5252 18.8661 8.03241 21.5046 8.03241C24.1238 8.03241 26.2971 10.5255 26.2971 13.6263C26.2971 16.7271 24.1238 19.2202 21.5046 19.2202C18.8854 19.2202 16.7121 16.7271 16.7121 13.6263Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M10.3863 36.7502V36.8639H10.5H13.1228H13.2365H13.2561V36.7502H13.3502V35.8315V35.7178H13.2365H11.5324V29.2248C11.5324 25.5737 14.5112 22.5949 18.1623 22.5949H18.276V22.4812V21.5625V21.4488H18.1623C13.8774 21.4488 10.3863 24.9399 10.3863 29.2248V36.7502Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M16.9732 36.7502V36.8639H17.0869H31.6918H31.8055H31.8251V36.7502H31.9192V29.2248C31.9192 24.9399 28.4281 21.4488 24.1432 21.4488H24.0295V21.5625V22.4812V22.5949H24.1432C27.7943 22.5949 30.7731 25.5737 30.7731 29.2248V35.7178H17.0869H16.9732V35.8315V36.7502Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M20.3623 30.1366L20.3627 30.1367C20.5693 30.1884 20.7611 30.2108 20.9607 30.2167V30.2378H21.0744C21.585 30.2378 22.0739 30.0947 22.5201 29.8311L22.5203 29.831C23.1715 29.4443 23.6396 28.8136 23.8232 28.0812C24.0269 27.3461 23.9037 26.5721 23.5178 25.9222C23.1311 25.2709 22.5004 24.8028 21.768 24.6193C21.0329 24.4155 20.2589 24.5387 19.609 24.9247C18.9573 25.3116 18.489 25.9429 18.3057 26.6759L18.4161 26.7035L18.3058 26.6755C17.9191 28.2021 18.8351 29.7497 20.3623 30.1366ZM20.6529 29.017C19.7864 28.7915 19.2492 27.9443 19.3929 27.0961L19.4255 26.9656C19.5354 26.5262 19.8098 26.1596 20.196 25.9205C20.5778 25.6842 21.0345 25.6281 21.4768 25.7387C21.9162 25.8486 22.2828 26.123 22.5219 26.5092C22.7583 26.891 22.8143 27.3477 22.7037 27.79C22.5939 28.2294 22.3194 28.596 21.9332 28.8351C21.5516 29.0713 21.0952 29.1275 20.6529 29.017Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M21.7055 28.9607L17.9833 32.0405C17.8939 31.6818 17.9795 31.2752 18.2292 30.9786C18.2292 30.9786 18.2292 30.9785 18.2293 30.9785L19.7537 29.1805L19.8267 29.0944L19.7411 29.0207L19.0375 28.4148L18.9506 28.34L18.8765 28.4274L17.3522 30.2254C16.5918 31.1094 16.6124 32.4439 17.3929 33.307L17.6856 33.6388L17.7462 33.5854L17.8238 33.6708L22.4368 29.8592L22.5237 29.7874L22.4527 29.6999L21.8663 28.9767L21.794 28.8874L21.7055 28.9607Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M27.1267 22.3477L27.0544 22.26L26.9666 22.3323L22.7724 25.7872L22.6847 25.8595L22.757 25.9473L23.3411 26.6564L23.4134 26.7442L23.5011 26.6719L27.6953 23.2169L27.7831 23.1446L27.7108 23.0568L27.1267 22.3477Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M15.9483 22.1035L15.8676 22.0234L15.7875 22.104L15.14 22.7558L15.0599 22.8365L15.1406 22.9166L18.6629 26.4156L18.7435 26.4958L18.8237 26.4151L19.4711 25.7633L19.5513 25.6827L19.4706 25.6025L15.9483 22.1035Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default BigCoach;
